import React from 'react'
import Svg from './Svg';
import { defaultGrey } from '../../prop-types';

interface ICheckboxOut{
  color?: string
  size?: number
}
export default function CheckboxOut({color = defaultGrey, size}: ICheckboxOut):  any {
  return (
    <Svg
      size={size}
      xmlns={"http://www.w3.org/2000/svg"}
      paths={[
        { fill:"none", d:"M0 0h24v24H0V0z" },
        {  fill: color, d:"M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"},
      ]}
    />
  )
}



